import { createServerFn } from "@tanstack/react-start";
import { readMatchupPreviewPage } from "./matchup-preview.server";
import { siteContext } from "./site.server";

/** The editable LIVE page with its selected public guide, or the native public preview. */
export const loadMatchupPreview = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  return readMatchupPreviewPage(drate);
});
